<template>
    <div>

        <c-panel v-if="editAluno && !dados.id">
            <div class="loading-form" style="min-height: 270px;">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </c-panel>

        <el-form @submit.native.prevent="onSubmitAluno" style="min-height: 270px;" v-if="!editAluno || dados.id" :model="dados" ref="dados" label-position="top">
            
            <c-panel v-if="editAluno && dados.matricula && dados.matricula.referencia_nacional && loadingEnturmacao == 2" title="Enturmação">                
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Curso Nacional" prop="referencia_nacional" key="referencia_nacional">
                            <el-select v-model="dados.matricula.referencia_nacional"  @change="changeTurma()">
                                <el-option v-for="(curso, i) in cursosNacionais" :key="i" :label="curso.nome" :value="curso.referencia_nacional"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Turma" prop="turma" key="turma">
                            <el-select v-model="dados.matricula.turma_id" >
                                <el-option-group v-for="(curso, i) in turmas" :key="i" :label="i">
                                    <el-option v-for="item in curso" :key="item.id" :label="item.vagas_disponiveis" :value="item.id"></el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <div v-if="!editAluno || dados.id">

                <c-panel title="DADOS GERAIS" titleIcon='fas fa-user'>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="dados.codigo_sed ? 13 : 18" :md="dados.codigo_sed ? 13 : 18">
                            <el-form-item label="Nome do Aluno" prop="nome" :rules="regras('nome')" key="nome">
                                <el-input v-model="dados.nome" maxlength="191" v-on:blur="checkIfAlunoExist()"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Data de Nascimento" prop="data_nascimento" :rules="regras('data_nascimento', [$dataBlur])" key="data_nascimento">
                                <el-input v-model="dados.data_nascimento" maxlength="191" v-mask="'##/##/####'" v-on:blur="checkIfAlunoExist()"></el-input>
                            </el-form-item>
                        </el-col>                        
                        <el-col :xs="24" :sm="5" :md="5" v-if="dados.codigo_sed">
                            <el-form-item label="RA (SED)" key="ra_sed">
                                <el-input readonly :value="dados.codigo_sed + '-' + (dados.sed_ra_digito || '') + '/' + (dados.sed_ra_uf || 'SP')" class="readonly"
                                    :title="dados.sed_status === 'SINCRONIZADA' ? 'Ficha sincronizada com a SED' : 'Há alterações ainda não enviadas à SED'"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="(sed.ativa || sed.consulta) && !dados.codigo_sed && (dados.sed_ra || (editAluno && dados.id))" :gutter="10">
                        <el-col :span="24">
                            <div class="sed-faixa">
                                <i class="fas fa-cloud"></i>
                                <template v-if="dados.sed_ra">
                                    Será vinculado ao RA <strong>{{ dados.sed_ra.numero }}-{{ dados.sed_ra.digito }}/{{ dados.sed_ra.uf }}</strong> já existente na SED.
                                </template>
                                <template v-else>
                                    Este aluno ainda não tem RA na SED. Ao salvar, ele será cadastrado lá — ou vinculado, se já existir.
                                    <el-button size="mini" type="primary" plain style="margin-left: 8px;" @click="buscarNaSed()">Buscar na SED</el-button>
                                </template>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="18" :md="18">
                            <el-form-item label="Nome Social do Aluno" prop="nome_social_aluno" :rules="regras('nome_social_aluno')" key="nome_social_aluno">
                                <el-input v-model="dados.nome_social_aluno" maxlength="191" v-on:blur="formatData('nome_social_aluno')"></el-input>
                            </el-form-item>
                        </el-col>   
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="INEP (12 dígitos)" prop="inep" :rules="regras('inep')" key="inep">
                                <el-input v-model="dados.inep" maxlength="191" v-mask="'############'" v-on:blur="formatData('inep', 12)"></el-input>
                            </el-form-item>
                        </el-col>                     
                    </el-row>
                    
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="(dados['cor'] == 5) ? 8 : 12" :md="(dados['cor'] == 5) ? 8 : 12">
                            <el-form-item label="Raça/Cor" prop="cor" :rules="regras('cor')" key="cor">
                                <el-select v-model="dados.cor">
                                    <el-option
                                        v-for="raca in $store.state.racas"
                                        :key="raca.id"
                                        :label="raca.nome"
                                        :value="raca.cod_censo">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="dados['cor'] == 5" :xs="24" :sm="(dados['cor'] == 5) ? 8 : 12" :md="(dados['cor'] == 5) ? 8 : 12">
                            <el-form-item label="Povos indígenas *" prop="povo_indigena_id" :rules="[$requiredChange]" key="povo_indigena_id">
                                <el-select v-model="dados.povo_indigena_id" filterable>
                                    <el-option
                                        v-for="(item, i) in povosIndigenas"
                                        :key="i"
                                        :label="item.nome"
                                        :value="parseInt(item.id)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>   
                        <el-col :xs="24" :sm="(dados['cor'] == 5) ? 8 : 12" :md="(dados['cor'] == 5) ? 8 : 12">
                            <el-form-item label="Sexo" prop="sexo" :rules="regras('sexo')" key="sexo">
                                <el-select v-model="dados.sexo">
                                    <el-option :key="0" label="MASCULINO" :value="0"></el-option>
                                    <el-option :key="1" label="FEMININO" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Filiação 1 (preferencialmente nome da mãe)" prop="mae" :rules="regras('mae')" key="mae">
                                <el-input v-model="dados.mae" maxlength="191" v-on:blur="formatData('mae')" style="width: calc(100% - 55px); float: left;"></el-input>
                                <el-button style="float: right; width: 40px; height: 40px;" @click="showSearchCbo('mae')" icon="el-icon-suitcase" circle title="Vincular CBO (ocupação)"></el-button>
                                <div v-if="dados.cbo_mae && dados.cbo_mae.id" style="clear: both; font-size: 12px; color: #409EFF; padding-top: 4px;">
                                    <i class="el-icon-suitcase"></i> CBO: {{ dados.cbo_mae.codigo }} - {{ dados.cbo_mae.nome }}
                                    <i class="el-icon-close u-pointer" style="color: #F56C6C; margin-left: 6px;" title="Remover vínculo" @click="removerCbo('mae')"></i>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Filiação 2" prop="pai" :rules="regras('pai')" key="pai">
                                <el-input v-model="dados.pai" maxlength="191" v-on:blur="formatData('pai')" style="width: calc(100% - 55px); float: left;"></el-input>
                                <el-button style="float: right; width: 40px; height: 40px;" @click="showSearchCbo('pai')" icon="el-icon-suitcase" circle title="Vincular CBO (ocupação)"></el-button>
                                <div v-if="dados.cbo_pai && dados.cbo_pai.id" style="clear: both; font-size: 12px; color: #409EFF; padding-top: 4px;">
                                    <i class="el-icon-suitcase"></i> CBO: {{ dados.cbo_pai.codigo }} - {{ dados.cbo_pai.nome }}
                                    <i class="el-icon-close u-pointer" style="color: #F56C6C; margin-left: 6px;" title="Remover vínculo" @click="removerCbo('pai')"></i>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Responsável" prop="responsavel" :rules="regras('responsavel')" key="responsavel">
                                <el-input v-model="dados.responsavel" maxlength="191" v-on:blur="formatData('responsavel')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Parentesco" prop="parentesco" :rules="regras('parentesco')" key="parentesco">
                                <el-select v-model="dados.parentesco">
                                    <el-option key="NÃO DECLARADA" label="NÃO DECLARADA" value="NÃO DECLARADA"></el-option>
                                    <el-option key="PAI" label="PAI" value="PAI"></el-option>
                                    <el-option key="MAE" label="MAE" value="MAE"></el-option>
                                    <el-option key="AVÔ(Ó)" label="AVÔ(Ó)" value="AVÔ(Ó)"></el-option>
                                    <el-option key="TIO(A)" label="TIO(A)" value="TIO(A)"></el-option>
                                    <el-option key="IRMÃO(Ã)" label="IRMÃO(Ã)" value="IRMÃO(Ã)"></el-option>
                                    <el-option key="PRIMO(A)" label="PRIMO(A)" value="PRIMO(A)"></el-option>
                                    <el-option key="PADRASTO" label="PADRASTO" value="PADRASTO"></el-option>
                                    <el-option key="MADRASTA" label="MADRASTA" value="MADRASTA"></el-option>
                                    <el-option key="OUTRO" label="OUTRO" value="OUTRO"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Telefone" prop="celular" :rules="regras('celular')" key="celular">
                                <el-input v-model="dados.celular" maxlength="191" v-mask="'(##) #########'" v-on:blur="formatData('celular', 14)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="(dados.nacionalidade == 3) ? 6 : 18" :md="(dados.nacionalidade == 3) ? 6 : 18">
                            <el-form-item label="Nacionalidade" prop="nacionalidade" :rules="regras('nacionalidade')" key="nacionalidade">
                                <el-select @change="changeNacionalidade()" v-model="dados.nacionalidade">
                                    <el-option :key="1" label="BRASILEIRA" :value="1"></el-option>
                                    <el-option :key="2" label="BRASILEIRA - NASCIDO NO EXTERIOR OU NATURALIZADO" :value="2"></el-option>
                                    <el-option :key="3" label="ESTRANGEIRA" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="dados.nacionalidade == 3" :xs="24" :sm="12" :md="12">
                            <el-form-item label="País de Nacionalidade" prop="pais_id" :rules="[$requiredChange]" key="pais_id">
                                <el-select v-model="dados.pais_id" clearable>
                                    <el-option v-for="(pais, i) in paises" :key="i" :label="pais.nome" :value="pais.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" v-if="dados.nacionalidade == 1">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Município de Nascimento" prop="municipio_nascimento.nome" :rules="[$requiredChange]" key="municipio_nascimento">
                                <el-input style="width: calc(100% - 55px); float: left" readonly v-model="dados.municipio_nascimento.nome" maxlength="191" class="readonly"></el-input>
                                <el-button style="float: right; width: 35px; height: 35px;" @click="showSearchMunNascimento" icon="el-icon-search" circle></el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </c-panel>

                <c-panel title="DOCUMENTAÇÃO" titleIcon='fas fa-portrait'>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="NIS (do aluno)" prop="nis" key="nis">
                                <el-input v-model="dados.nis" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="CPF (do aluno)" prop="cpf" :rules="regras('cpf')" key="cpf">
                                <el-input v-model="dados.cpf" maxlength="191" v-mask="'###.###.###-##'" v-on:blur="formatData('cpf', 14)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Cartão do SUS (do aluno)" prop="cartao_sus" key="cartao_sus">
                                <el-input v-model="dados.cartao_sus" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="RG (do aluno)" prop="rg" :rules="regras('rg')" key="rg">
                                <el-input v-model="dados.rg" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Data de Emissão" prop="data_emissao_rg" :rules="regras('data_emissao_rg')" key="data_emissao_rg">
                                <el-input v-model="dados.data_emissao_rg" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_emissao_rg', 10)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Orgão Emissor" prop="orgao_emissor_rg" :rules="regras('orgao_emissor_rg')" key="orgao_emissor_rg">
                                <el-input v-model="dados.orgao_emissor_rg" maxlength="191" v-on:blur="formatData('orgao_emissor_rg')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="UF RG" prop="uf_rg" :rules="regras('uf_rg')" key="uf_rg">
                                <el-input v-model="dados.uf_rg" maxlength="191" v-on:blur="formatData('uf_rg')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="(dados.modelo_registro === 0 || dados.modelo_registro === 1) ? 20 : 24" :md="(dados.modelo_registro === 0 || dados.modelo_registro === 1) ? 20 : 24">
                            <el-form-item label="Modelo do Registro" prop="modelo_registro" key="modelo_registro">
                                <el-select @change="changeModeloRegistro()" v-model="dados.modelo_registro">
                                    <el-option key="" label="" value=""></el-option>
                                    <el-option :key="0" label="ANTIGO" :value="0"></el-option>
                                    <el-option :key="1" label="NOVO" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4" :md="4" v-if="dados.modelo_registro === 0 || dados.modelo_registro === 1">
                            <el-form-item label="Data de Emissão" prop="data_emissao_registro" key="data_emissao_registro">
                                <el-input v-model="dados.data_emissao_registro" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_emissao_registro', 10)"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <template v-if="dados.modelo_registro === 0">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="16" :md="16">
                                <el-form-item label="Registro" prop="reg_nasc_antigo_registro" :rules="[$requiredBlur]" key="reg_nasc_antigo_registro">
                                    <el-input v-model="dados.reg_nasc_antigo_registro" maxlength="191" v-on:blur="formatData('reg_nasc_antigo_registro')"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="Folha" prop="reg_nasc_antigo_folha" :rules="[$requiredBlur]" key="reg_nasc_antigo_folha">
                                    <el-input v-model="dados.reg_nasc_antigo_folha" maxlength="191" v-on:blur="formatData('reg_nasc_antigo_folha')"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="Livro" prop="reg_nasc_antigo_livro" :rules="[$requiredBlur]" key="reg_nasc_antigo_livro">
                                    <el-input v-model="dados.reg_nasc_antigo_livro" maxlength="191" v-on:blur="formatData('reg_nasc_antigo_livro')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Cartório" :rules="[$requiredBlur]" prop="cartorio.nome">
                                    <el-input readonly style="width: calc(100% - 55px); float: left" v-model="dados.cartorio.nome" maxlength="191" class="readonly"></el-input>
                                    <el-button style="float: right; width: 40px; height: 40px;" @click="showSearchCartorio" icon="el-icon-search" circle></el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10" v-if="dados.cartorio.cidade">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Cidade do Cartório" prop="cartorio_id">
                                    <el-input readonly v-model="dados.cartorio.cidade.nome" maxlength="191" class="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </template>
                    <template v-if="dados.modelo_registro === 1">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Número (com 32 dígitos)" prop="registro_nasc_novo" :rules="[$requiredBlur, $registroBlur]" key="registro_nasc_novo">
                                    <el-input v-model="dados.registro_nasc_novo" maxlength="191" v-mask="'######.##.##.####.#.#####.###.#######-##'" v-on:blur="formatData('registro_nasc_novo', 40)"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </template>
                </c-panel>

                <c-panel title="DADOS MÉDICOS E SOCIAIS" titleIcon='fas fa-briefcase-medical'>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Recebe Bolsa Família?" prop="recebe_bolsa_familia" :rules="regras('recebe_bolsa_familia')" key="recebe_bolsa_familia">
                                <el-select v-model="dados.recebe_bolsa_familia">
                                    <el-option :key="true" label="SIM" :value="true"></el-option>
                                    <el-option :key="false" label="NÃO" :value="false"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="9" :md="9">
                            <el-form-item label="Alergias" prop="alergias" :rules="regras('alergias')" key="alergias">
                                <el-select v-model="dados.alergias" multiple filterable>
                                    <el-option
                                        v-for="(item, i) in alergias"
                                        :key="i"
                                        :label="item.nome"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="9" :md="9">
                            <el-form-item label="Doenças" prop="doencas" :rules="regras('doencas')" key="doencas">
                                <el-select v-model="dados.doencas" multiple filterable>
                                    <el-option
                                        v-for="(item, i) in doencas"
                                        :key="i"
                                        :label="item.nome"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row> 
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Transtorno(s) que impacta(m) o desenvolvimento da aprendizagem" prop="transtornoAprendizagem" :rules="regras('transtornoAprendizagem')" key="transtornoAprendizagem">
                                <el-select v-model="dados.transtornoAprendizagem" multiple filterable>
                                    <el-option
                                        v-for="(item, i) in transtornoAprendizagem"                                        
                                        :key="i"
                                        :label="item.nome"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>                    
                    <!-- Integração SED: exigido para estudante com deficiência, TEA ou altas habilidades. -->
                    <el-row :gutter="10" v-if="sed.ativa && dados.deficiencias && dados.deficiencias.length">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="Nível de apoio (exigido pela SED)" prop="sed_nivel_suporte" key="sed_nivel_suporte">
                                <el-select v-model="dados.sed_nivel_suporte" clearable placeholder="Selecione">
                                    <el-option :key="1" label="Nível 1" :value="1"></el-option>
                                    <el-option :key="2" label="Nível 2" :value="2"></el-option>
                                    <el-option :key="3" label="Nível 3" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" v-for="(item, i) in dados.deficiencias" :key="i">
                        <el-col :xs="24" :sm="17" :md="17">
                            <el-form-item label="Deficiência" prop="deficiencias" :rules="regras('deficiencias')" key="deficiencias">
                                <el-select v-model="dados.deficiencias[i].deficiencia_id" clearable>
                                    <el-option
                                        style="text-transform: uppercase;"
                                        v-for="(item, i) in deficiencias"
                                        :key="i"
                                        :label="item.nome"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="CID-10" prop="cid10" :rules="regras('cid10')" key="cid10">                            
                                <el-input v-model="dados.deficiencias[i].cid10" maxlength="191"></el-input>                               
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :xs="24" :sm="4" :md="4">
                            <el-upload
                                :key="dados.deficiencias[i].deficiencia_id"
                                style="display: inline-block; display: flex; margin-top: 16px; border-bottom: 1px solid #989898"
                                :action="`${$store.state.config.baseUrlApi}/api/file/upload-file/${i}`"
                                :on-change="handleChange"
                                :file-list="dados.deficiencias[i].arquivosCid10">
                                <el-button size="small" type="primary" style="margin-bottom: 4px;">
                                    <i class="fas fa-file"></i>
                                </el-button>
                            </el-upload>
                        </el-col> -->
                        <el-col :xs="24" :sm="1" :md="1">
                            <el-button v-if="i != (dados.deficiencias && dados.deficiencias.length - 1)" @click="removerDeficiencia(i)" type="danger" icon="el-icon-delete" style="margin-top: 21px;"></el-button>

                            <el-button v-if="i == (dados.deficiencias && dados.deficiencias.length - 1)" @click="adicionarDeficiencia()" type="primary" style="margin-top: 21px;">
                                <i class="fas fa-plus"></i>
                            </el-button>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10" v-if="dados.deficiencias && dados.deficiencias.length > 0 && dados.deficiencias[0].deficiencia_id">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Recursos para uso do(a) aluno(a) e para a participação em avaliações do Inep (Saeb):" prop="recursosProvas" key="recursosProvas">
                                <el-select v-model="dados.recursosProvas" multiple>
                                    <el-option
                                        style="text-transform: uppercase;"
                                        v-for="(item, i) in recursosProvas"
                                        :key="i"
                                        :label="item.nome"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    
                </c-panel>

                <c-panel title="ENDEREÇAMENTO" titleIcon='fas fa-map-marker-alt'>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item label="CEP" prop="cep" :rules="regras('cep')" key="cep">
                                <el-input v-model="dados.cep" maxlength="191" v-mask="'#####-###'" :loading="buscandoCep" v-on:blur="buscarViaCep()"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="16" :md="16">
                            <el-form-item label="Logradouro" prop="logradouro" :rules="regras('logradouro')" key="logradouro">
                                <el-input v-model="dados.logradouro" maxlength="191" v-on:blur="formatData('logradouro'); localizarSilencioso()"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item label="Número" prop="numero" :rules="regras('numero')" key="numero">
                                <el-input v-model="dados.numero" maxlength="191" v-on:blur="localizarSilencioso()"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Bairro" prop="bairro" :rules="regras('bairro')" key="bairro">
                                <el-input v-model="dados.bairro" maxlength="191" v-on:blur="localizarSilencioso()"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Complemento" prop="complemento" :rules="regras('complemento')" key="complemento">
                                <el-input v-model="dados.complemento" maxlength="191" v-on:blur="formatData('complemento')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item label="Zona" prop="localizacao_zona" :rules="regras('localizacao_zona')" key="localizacao_zona">
                                <el-select v-model="dados.localizacao_zona">
                                    <el-option v-for="(item, i) in $CONSTANTS.LOCALIZACAO_ZONA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Localização Diferenciada" prop="localizacao_diferenciada" :rules="regras('localizacao_diferenciada')" key="localizacao_diferenciada">
                                <el-select v-model="dados.localizacao_diferenciada">
                                    <el-option :key="1" label="ÁREA DE ASSENTAMENTO" :value="1"></el-option>
                                    <el-option :key="2" label="TERRA INDÍGENA" :value="2"></el-option>
                                    <el-option :key="3" label="COMUNIDADE QUILOMBOLA" :value="3"></el-option>
                                    <el-option :key="7" label="NÃO ESTÁ EM ÁREA DE LOCALIZAÇÃO DIFERENCIADA" :value="7"></el-option>
                                    <el-option :key="8" label="ÁREA ONDE SE LOCALIZAM POVOS E COMUNIDADES TRADICIONAIS" :value="8"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="geo.ativa ? 14 : 24" :md="geo.ativa ? 14 : 24">
                            <!-- Cidade: select com busca no servidor (5.570 cidades — não carrega a lista inteira). O CEP preenche
                                 sozinho; CEP geral do município (ex.: 13940-000) é resolvido pelo BrasilAPI quando o ViaCEP não acha. -->
                            <el-form-item label="Cidade" :rules="regras('cidade')" prop="cidade_id" key="cidade">
                                <el-select v-model="dados.cidade_id" filterable remote clearable placeholder="Digite o nome da cidade"
                                    :remote-method="buscarCidades" :loading="buscandoCidade" @change="selecionarCidade">
                                    <el-option v-for="c in cidadesOpcoes" :key="c.id" :label="c.nome" :value="c.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- Coordenada do endereço: preenchida pela geocodificação (ao digitar o CEP / ao carregar) ou pelo pino no
                             mapa. Somente leitura — o servidor só aceita coordenada que valha para o endereço informado. -->
                        <template v-if="geo.ativa">
                            <el-col :xs="12" :sm="4" :md="4">
                                <el-form-item label="Latitude" key="lat">
                                    <el-input readonly :value="geoConfirmada ? formataCoord(dados.lat) : ''" class="readonly" placeholder="—"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="4" :md="4">
                                <el-form-item label="Longitude" key="lng">
                                    <el-input readonly :value="geoConfirmada ? formataCoord(dados.lng) : ''" class="readonly" placeholder="—"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="2" :md="2">
                                <el-form-item label=" " key="geo-btn">
                                    <!-- azul = coordenada exata (número, pino ou SED); amarelo = aproximada (centro da rua/cidade); cinza = sem coordenada -->
                                    <el-button plain :type="geoConfirmada ? (geoAproximada ? 'warning' : 'primary') : 'default'" icon="el-icon-location-outline" style="width: 100%;"
                                        :title="geoConfirmada ? (geoAproximada ? 'Localização APROXIMADA (centro da rua ou da cidade) — clique para ajustar no mapa' : 'Endereço localizado — clique para ajustar no mapa') : 'Endereço ainda não localizado — clique para posicionar no mapa'"
                                        @click="abrirMapaEndereco()">Mapa</el-button>
                                </el-form-item>
                            </el-col>
                        </template>
                    </el-row>

                    <div v-if="input_autorizacao">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Código de Autorização" prop="autorizacao_smed" key="autorizacao_smed">
                                    <el-input v-model="dados.autorizacao_smed" maxlength="191"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-alert title="Você poderá informar um código de autorização gerado pela SMED para continuar." type="warning"></el-alert>
                    </div>
                </c-panel>
                <c-panel title="OUTRAS INFORMAÇÕES" titleIcon='fas fa-clipboard-list'>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Observação" prop="observacao" :rules="regras('observacao')" key="observacao">
                                <el-input type="textarea" autosize v-model="dados.observacao"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </c-panel>

                <c-panel title="ANEXOS" titleIcon='fas fa-paperclip'>
                    <anexos ref="anexos" tipo="aluno" :id="dados.id"></anexos>
                </c-panel>

                <el-row :gutter="10">
                    <div class="u-text-right u-mt-20">
                        <el-button type="primary" id="btn-aluno" native-type="submit">{{ (call == 'index') ? 'SALVAR' : 'PROXIMO >' }}</el-button>
                    </div>
                </el-row>

            </div>
        </el-form>

        <search-cartorio key="searchCartorio" v-on:close="searchCartorio = false" :open="searchCartorio" v-on:emitCartorio="emitCartorio"></search-cartorio>
        <search-cbo key="searchCbo" v-on:close="searchCbo = false" :open="searchCbo" v-on:emitCbo="emitCbo"></search-cbo>
        <search-cidade key="searchCidade" v-on:close="searchCidade = false" :open="searchCidade" v-on:emitCidade="emitMunNascimento"></search-cidade>
        <search-endereco key="searchEndereco" v-on:close="searchEndereco = false" :open="searchEndereco" v-on:emitEndereco="emitEndereco"></search-endereco>

        <!-- Localização do endereço do aluno no mapa -->
        <!-- O mapa só é montado depois de o dialog terminar de abrir (@opened): o vue2-google-maps precisa do elemento já no
             DOM, senão falha com "IntersectionObserver: parameter 1 is not of type 'Element'". -->
        <el-dialog :close-on-click-modal="false" :show-close="false" title="LOCALIZAÇÃO DO ENDEREÇO DO ALUNO" width="70%" top="30px" :visible.sync="geo.modal"
            @opened="geo.aberto = true" @closed="geo.aberto = false">
            <mapa-endereco class="u-mt-20" v-if="geo.modal && geo.aberto" :endereco="geo.endereco" :motivo="geo.motivo" :sugestao="geo.sugestao" :posicionado="geo.posicionado"
                v-on:confirmar="confirmarMapaEndereco" v-on:cancelar="cancelarMapaEndereco"></mapa-endereco>
        </el-dialog>

        <!-- Integração SED-SP: busca obrigatória antes de cadastrar (um RA duplicado não pode ser desfeito pela integração). -->
        <el-dialog :close-on-click-modal="false" title="BUSCA NA SED" width="70%" :visible.sync="sedBusca.visivel">
            <div v-loading="sedBusca.carregando" style="min-height: 80px;">
                <el-alert v-if="!sedBusca.carregando && sedBusca.candidatos.length === 0" type="success" :closable="false" show-icon
                    title="Nenhum aluno encontrado na SED com esses dados." description="Pode seguir com o cadastro: ao salvar, a SED vai gerar o RA."></el-alert>

                <div v-for="c in sedBusca.candidatos" :key="c.ra.numero" class="sed-candidato">
                    <div><strong>{{ c.nome }}</strong> <el-tag size="mini" :type="c.confianca === 'ALTA' ? 'danger' : (c.confianca === 'MEDIA' ? 'warning' : 'info')">{{ rotuloConfianca(c.confianca) }}</el-tag></div>
                    <div class="sed-linha">RA {{ c.ra.numero }}-{{ c.ra.digito }}/{{ c.ra.uf }} · nascimento {{ c.data_nascimento }} · mãe: {{ c.mae || '—' }}</div>
                    <div class="sed-linha" v-if="c.matricula_ativa" :style="{ color: c.matricula_ativa.na_nossa_rede ? '#606266' : '#e6a23c' }">
                        Matrícula ativa em {{ c.matricula_ativa.ano }}: {{ c.matricula_ativa.escola }} ({{ c.matricula_ativa.rede }} — {{ c.matricula_ativa.municipio }}).
                        <span v-if="!c.matricula_ativa.na_nossa_rede">Para matricular aqui, a SED exige a inscrição de transferência (o sistema oferece no momento da matrícula).</span>
                    </div>
                    <div class="sed-linha" v-else>Sem matrícula ativa neste ano.</div>
                    <div style="margin-top: 6px;">
                        <el-button v-if="c.ja_vinculado_no_smge" size="mini" type="warning" plain @click="$router.push('/admin/aluno/edit/' + c.ja_vinculado_no_smge.aluno_id)">Já está cadastrado no SMGE — abrir ficha</el-button>
                        <el-button v-else size="mini" type="primary" @click="usarCadastroSed(c)">Usar este cadastro</el-button>
                    </div>
                </div>
            </div>
            <span slot="footer">
                <el-button v-if="sedBusca.candidatos.length > 0" @click="naoEhNenhumDaSed()">Não é nenhum destes — cadastrar novo</el-button>
                <el-button type="primary" @click="sedBusca.visivel = false">Fechar</el-button>
            </span>
        </el-dialog>

        <!-- Integração SED: sem CPF nem certidão nova, a SED exige a justificativa de ausência de documentos -->
        <el-dialog :close-on-click-modal="false" title="JUSTIFICATIVA DE AUSÊNCIA DE DOCUMENTOS" width="70%" :visible.sync="justificativaDocumentos.visivel" append-to-body>
            <div v-if="justificativaDocumentos.visivel" class="u-mt-20">
                <p style="margin-top: 0;">
                    O aluno está sem CPF e sem certidão de nascimento (modelo novo, 32 dígitos). Para cadastrá-lo na SED,
                    informe o motivo:
                </p>
                <el-radio-group v-model="justificativaDocumentos.valor" class="u-mb-10" style="display: flex; flex-direction: column; gap: 12px;">
                    <el-radio :label="1">O aluno não possui documentos</el-radio>
                    <el-radio :label="2">A escola não recebeu os documentos</el-radio>
                </el-radio-group>
                <el-alert v-if="justificativaDocumentos.outras.length" type="warning" :closable="false" show-icon class="u-mt-15"
                    title="A SED também apontou:">
                    <div v-for="(m, i) in justificativaDocumentos.outras" :key="i">• {{ m }}</div>
                </el-alert>
                <div class="u-text-right u-mt-20">
                    <el-button @click="justificativaDocumentos.visivel = false">Cancelar</el-button>
                    <el-button type="primary" :disabled="!justificativaDocumentos.valor" @click="confirmarJustificativaDocumentos()">Confirmar e salvar</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="CADASTROS SIMILARES" width="90%" :visible.sync="dialogCadastrosSimilares">
            <div v-if="dialogCadastrosSimilares" style="margin-top: 20px;">

                <i style="margin-bottom: 20px; display: block;">
                    Existe cadastro similar ao cadastro de {{ dados.nome }} no sistema.
                    É possível que este (a) aluno (a) já possua cadastro no sistema conforme apresentado na tabela abaixo.<br>
                    Você poderá realizar a matrícula a partir da (s) opção (ões) a seguir ou fechar esta tela e continuar o cadastro de {{ dados.nome }}.
                </i>

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 70px;">cod</th>
                                <th>Nome</th>
                                <th>Data Nasicmento</th>
                                <th>Filiação 1</th>
                                <th>Instituição</th>
                                <th style="width: 170px;" class="u-text-center">Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in cadastrosSimilares" :key="item.id">
                                <td>{{ item.id }}</td>
                                <td>{{ item.nome }}</td>
                                <td>{{ $moment(item.data_nascimento).format('DD/MM/YYYY') }}</td>
                                <td>{{ item.mae }}</td>
                                <td>{{ (item.matriculas.length > 0) ? item.matriculas[0].instituicao.apelido : '-' }}</td>
                                <td class="u-text-center acao">

                                    <span style="color: #ff0000;" v-if="item.matriculas.length > 0">
                                        MATRICULADO (A)
                                    </span>

                                    <a v-if="item.matriculas.length == 0" @click="openMatriculaSimilar(item.id)" href="javascript:void(0)">
                                        REALIZAR MATRÍCULA
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="u-text-right u-mt-20">
                    <el-button type="danger" @click="dialogCadastrosSimilares = false">FECHAR</el-button>
                </div>
            </div>
        </el-dialog>


    </div>
</template>
<script>

import Vue from 'vue'

import searchCartorio from "@/components/search/search-cartorio"
import searchCbo from "@/components/search/search-cbo"
import searchCidade from "@/components/search/search-cidade"
import mapaEndereco from '@/components/aluno/mapa-endereco'
import searchEndereco from "@/components/search/search-endereco"
import anexos from "@/shared/anexos/anexos.vue"
import InputImage from '@/shared/input-image/input-image.vue'
import { CAMPOS_ALUNO, CHAVE_CAMPOS_ALUNO } from "@/shared/constants/camposObrigatorios"

export default {
    props: ['paramId', 'call'],
    data: () => ({
        // Geolocalização do endereço (API: config/geo.php). aguardando = resolve() da Promise enquanto o mapa está aberto.
        geo: { ativa: false, modal: false, endereco: '', motivo: '', sugestao: null, posicionado: false, hash: null, aguardando: null, carregando: false, consultando: false, aberto: false },
        // Integração SED-SP
        sed: { ativa: false },
        sedBusca: { visivel: false, carregando: false, feita: false, candidatos: [] },
        // Justificativa de ausência de documentos pedida pela SED (1 = aluno não possui; 2 = escola não recebeu)
        justificativaDocumentos: { visivel: false, valor: null, outras: [] },
        camposObrigatorios: [],
        fotoFile: '',
        fotoUrl: '',
        loadingEnturmacao: 1,
        acentuacaoInstituicao: false,
        cursosNacionais: [],
        turmas: [],
        buscandoCep: false,
        buscandoCidade: false,
        cidadesOpcoes: [],   // opções do select de cidade (busca remota + a cidade já gravada)
        input_autorizacao: false,
        dialogCadastrosSimilares: false,
        cadastrosSimilares: [],
        searchCartorio: false,
        searchCbo: false,
        cboAlvo: null,
        searchCidade: false,
        searchEndereco: false,
        editAluno: false,
        alert: false,
        alergias: [],
        doencas: [],
        transtornoAprendizagem: [],
        deficiencias: [],
        recursosProvas: [],
        paises: [],
        povosIndigenas: [],
        religioes: [],
        tiposRendaFamiliar: [],
        situacoesFamiliares: [],
        dados: {
            referencia_nacional: '',
            turma: '',
            recursosProvas: [],
            povo_indigena_id: '',
            possui_internet: '',
            possui_computador: '',
            qtd_smartphones: '',
            autorizacao_smed: '',
            alergias: [],
            doencas: [],
            deficiencias: [],
            transtornoAprendizagem: [],
            id: '',
            cpf: '',
            rg: '',
            data_emissao_rg: '',
            orgao_emissor_rg: '',
            uf_rg: '',
            nome: '',
            inep: '',
            nome_aluno_censo: '',
            data_nascimento: '',
            pai: '',
            mae: '',
            responsavel: '',
            parentesco: '',
            sexo: '',
            cor: '',
            nacionalidade: '',
            cartao_sus: '',
            nis: '',
            modelo_registro: '',
            tipo_registro: '',
            registro_nasc_novo: '',
            reg_nasc_antigo_registro: '',
            reg_nasc_antigo_folha: '',
            reg_nasc_antigo_livro: '',
            data_emissao_registro: '',
            logradouro: '',
            numero: '',
            bairro: '',
            cep: '',
            complemento: '',
            localizacao_zona: '',
            localizacao_diferenciada: '',
            telefone: '',
            celular: '',
            celular_outro: '',
            recebe_bolsa_familia: '',
            religiao_id: '',
            tipo_renda_familiar_id: '',
            situacao_familiar_id: '',
            cbo_mae_id: '',
            cbo_pai_id: '',
            cbo_mae: { id: '', codigo: '', nome: '' },
            cbo_pai: { id: '', codigo: '', nome: '' },
            observacao: '',
            situacao: '',
            pais_id: '',
            municipio_nascimento_id: '',
            cartorio_id: '',
            cidade_id: '',
            cidade: {
                id: '',
                nome: '',
                estado: {
                    id: '',
                    nome: ''
                }
            },
            pais: {
                id: '',
                nome: ''
            },
            municipio_nascimento: {
                id: '',
                nome: ''
            },
            cartorio: {
                id: '',
                nome: '',
                cidade: {
                    id: '',
                    nome: ''
                }
            }
        }

    }),
    computed: {
        geoConfirmada() {
            return !!(this.dados.lat && this.dados.lng && this.dados.geo_endereco_hash);
        },
        geoAproximada() {
            return this.geoConfirmada && ['GEOMETRIC_CENTER', 'APPROXIMATE'].includes(this.dados.geo_precisao);
        }
    },
    mounted(){

        this.getGeolocalizacaoAtiva();
        this.getIntegracaoSed();

        this.initFormAluno();
        this.aplicarVerificacaoSed();
        this.carregarCamposObrigatorios();

        // Aluno novo: usa a instituição ativa selecionada. (Na edição, o getAlunoById usa a instituição do aluno.)
        if(this.$store.state.config.instituicao && this.$store.state.config.instituicao.id)
            this.carregarAcentuacaoInstituicao(this.$store.state.config.instituicao.id);
    },
    methods:{
        // Carrega a lista global de campos obrigatórios (configurável em Configurações do Sistema).
        carregarCamposObrigatorios(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/parametro-sistema/getValor/${CHAVE_CAMPOS_ALUNO}`, this.$store.getters.getHeaderAuth)
                .then(r => {
                    const v = r.data && r.data.valor;
                    this.camposObrigatorios = Array.isArray(v) ? v : [];
                })
                .catch(() => { /* mantém vazio; nenhum campo torna-se obrigatório dinamicamente */ });
        },
        // Monta o array de regras de um campo: injeta 'required' se estiver configurado como obrigatório.
        regras(key, extras = []){

            const rules = Array.isArray(extras) ? extras.slice() : [];
            if(!this.camposObrigatorios.includes(key)) return rules;

            // Deficiência/CID-10 são repetíveis (dados.deficiencias[i]); exigem validação customizada.
            if(key === 'deficiencias'){
                rules.unshift({ validator: (r, v, cb) => {
                    const tem = (this.dados.deficiencias || []).some(d => d.deficiencia_id);
                    tem ? cb() : cb(new Error('Informe ao menos uma deficiência.'));
                }, trigger: 'change' });
                return rules;
            }
            if(key === 'cid10'){
                rules.unshift({ validator: (r, v, cb) => {
                    const faltando = (this.dados.deficiencias || []).some(d => d.deficiencia_id && !d.cid10);
                    faltando ? cb(new Error('Informe o CID-10 das deficiências.')) : cb();
                }, trigger: 'blur' });
                return rules;
            }

            const campo = CAMPOS_ALUNO.find(c => c.key === key);
            const trigger = (campo && campo.trigger) ? campo.trigger : 'blur';
            rules.unshift({ required: true, message: 'Campo obrigatório.', trigger });
            return rules;
        },
        getRefNacionalByInstituicao() {

            let data = {
                "i": this.dados.matricula.instituicao_id,
                "p": this.$store.state.config.periodo.id
            };

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/curso/getRefNacionalByInstituicao`, data, this.$store.getters.getHeaderAuth).then(response => {

                this.cursosNacionais = response.data;
                this.getTurmas();

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        changeTurma() {
            this.dados.matricula.turma_id = null;
            this.getTurmas();
        },
        getTurmas(){

            let data = {
                instituicao_id: this.dados.matricula.instituicao_id,
                periodo_letivo_id: this.$store.state.config.periodo.id,
                referencia_nacional: this.dados.matricula.referencia_nacional,
                data_nascimento: this.dados.data_nascimento,
                aluno_id: this.dados.id,
                id_pre_matricula: null
            };

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/getAllByReferenciaNacional`, data, this.$store.getters.getHeaderAuth).then(response => {

                if(!this.$route.query.turma_id) {
                    this.dados.turma = '';
                }

                this.turmas = response.data.turmas;
                this.loadingEnturmacao = 2;

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        handleChange(event){

            if(event && event.response){

                Vue.set(this.dados.deficiencias[event.response['i']].arquivosCid10, 0, {
                    name: event.response['name'],
                    url: event.response['url']
                });
            }
        },
        adicionarDeficiencia(){
            this.dados.deficiencias.push({
                deficiencia_id: '',
                cid10: '',
                nome: ''
                // arquivosCid10: []
            });
        },
        removerDeficiencia(i){
            this.dados.deficiencias.splice(i, 1);
        },
        openMatriculaSimilar(id){

            this.dialogCadastrosSimilares = false;
            this.getAlunoById(id);
            this.editAluno = true;
        },
        async checkIfAlunoExistByDocumento(){

            let documento = '';

            if(this.dados.cpf) {
                documento = this.dados.cpf;
            }

            if(this.dados.registro_nasc_novo) {
                documento = this.dados.registro_nasc_novo;
            }

            if(!documento){
                return;
            }

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/checkIfAlunoExistByDocumento`, { documento }, this.$store.getters.getHeaderAuth);

            if(response.data.id){

                const queryParams = this.$route.query;

                this.$router.push({ path: `/admin/matricula/passo-a-passo/${response.data.id}`, query: queryParams }).catch(() => {})

            } else {

                this.checkIfAlunoExist();                
            }

        },
        // ------------------------------------------------------- Geolocalização do endereço
        getGeolocalizacaoAtiva(){
            // Sem endereço não consulta o Google: só diz se a geocodificação está ligada na API.
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/geocodificar`, {}, this.$store.getters.getHeaderAuth)
                .then(r => { this.geo.ativa = !!(r.data && r.data.ativa); if(this.geo.ativa) this.localizarSilencioso(); }).catch(() => {});
        },
        dadosGeo(){
            const d = this.dados;
            return { id: d.id || null, logradouro: d.logradouro, numero: d.numero, bairro: d.bairro, cep: d.cep, cidade_id: d.cidade_id,
                     lat: d.lat, lng: d.lng, geo_endereco_hash: d.geo_endereco_hash, geo_precisao: d.geo_precisao };
        },
        formataCoord(v){
            const n = Number(String(v === null || v === undefined ? '' : v).replace(',', '.'));
            return isNaN(n) || !v ? '' : n.toFixed(6);
        },
        aplicarGeo(lat, lng, hash, precisao){
            Vue.set(this.dados, 'lat', lat);
            Vue.set(this.dados, 'lng', lng);
            Vue.set(this.dados, 'geo_endereco_hash', hash);
            Vue.set(this.dados, 'geo_precisao', precisao);
        },
        async consultarGeo(silencioso){
            if(!silencioso) window.eventBus.$emit('loading', true);
            try {
                const r = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/geocodificar`, this.dadosGeo(), this.$store.getters.getHeaderAuth);
                if(!silencioso) window.eventBus.$emit('loading', false);
                return r.data || {};
            } catch(e) {
                if(!silencioso){ window.eventBus.$emit('loading', false); this.$store.commit('throwException', e); }
                return null;
            }
        },
        // Localiza em segundo plano ao sair de qualquer campo do endereço (CEP, logradouro, número, bairro, cidade):
        // quando já há logradouro + número + cidade, consulta; encontrado com precisão, a coordenada entra e o botão
        // do mapa escurece; senão fica claro e o mapa abre no salvar (ou no clique). Não depende do CEP.
        async localizarSilencioso(){
            // Sem número o Google só devolve o centro da rua (nunca aceito): espera o número antes de consultar.
            if(!this.geo.ativa || this.geoConfirmada || !this.dados.logradouro || !this.dados.cidade_id || !String(this.dados.numero || '').trim() || this.geo.modal || this.geo.consultando) return;
            this.geo.consultando = true;
            const r = await this.consultarGeo(true);
            this.geo.consultando = false;
            if(r && r.ativa && r.status === 'OK') this.aplicarGeo(r.lat, r.lng, r.hash, r.precisao);
        },
        // Chamado no salvar. true = pode gravar (coordenada garantida); false = abortar.
        async garantirGeolocalizacao(){
            const r = await this.consultarGeo();
            if(!r) return false;
            if(!r.ativa) return true;

            if(r.status === 'OK'){
                this.aplicarGeo(r.lat, r.lng, r.hash, r.precisao);
                return true;
            }
            if(!r.hash){
                this.$alert('Informe o logradouro e a cidade do aluno para localizar o endereço.', 'Atenção', { confirmButtonText: 'OK' }).catch(() => {});
                return false;
            }
            return this.abrirMapa(r, false);
        },
        // Botão "Posicionar / Ajustar no mapa": o pino começa na coordenada atual, se houver.
        async abrirMapaEndereco(){
            const r = await this.consultarGeo();
            if(!r) return;
            if(!r.hash){
                this.$alert('Informe o logradouro e a cidade do aluno antes de posicionar no mapa.', 'Atenção', { confirmButtonText: 'OK' }).catch(() => {});
                return;
            }
            const num = v => Number(String(v).replace(',', '.'));
            if(this.dados.lat && this.dados.lng){
                r.sugestao = { lat: num(this.dados.lat), lng: num(this.dados.lng) };
            } else if(r.status === 'OK'){
                r.sugestao = { lat: r.lat, lng: r.lng };
            }
            r.posicionado = !!(this.dados.lat && this.dados.lng) || r.status === 'OK';
            await this.abrirMapa(r, true);
        },
        // Abre o modal e devolve uma Promise resolvida no confirmar (true) / cancelar (false).
        abrirMapa(r, ajuste){
            this.geo.endereco    = r.endereco || '';
            this.geo.motivo      = ajuste ? '' : (r.motivo || '');
            this.geo.sugestao    = r.sugestao || null;
            this.geo.posicionado = r.posicionado !== undefined ? r.posicionado : false;
            this.geo.hash        = r.hash;
            this.geo.modal       = true;
            return new Promise(resolve => { this.geo.aguardando = resolve; });
        },
        confirmarMapaEndereco(p){
            this.aplicarGeo(p.lat, p.lng, this.geo.hash, 'MANUAL');
            this.fecharMapa(true);
        },
        cancelarMapaEndereco(){ this.fecharMapa(false); },
        fecharMapa(ok){
            this.geo.modal = false;
            const f = this.geo.aguardando; this.geo.aguardando = null;
            if(f) f(ok);
        },
        // Mudou o endereço: a coordenada deixa de valer (a nova localização roda ao sair do campo).
        invalidarGeo(novo, antigo){
            if(this.geo.carregando || antigo === undefined || antigo === novo) return;
            if(this.dados.geo_endereco_hash) Vue.set(this.dados, 'geo_endereco_hash', null);
        },
        // ---------------------------------------------------------------- Integração SED-SP
        getIntegracaoSed(){

            const inst = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null;

            // Perfil de rede (sem escola selecionada): o envio é único para toda a rede — pergunta pelo apoio geral.
            if(!inst){
                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/sed/aluno/apoio`, this.$store.getters.getHeaderAuth).then(response => {
                    this.sed = { ativa: !!response.data.envio, consulta: !!response.data.consulta, unidades: [] };
                }).catch(() => { this.sed = { ativa: false }; });
                return;
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/sed/escola/` + inst, this.$store.getters.getHeaderAuth).then(response => {
                this.sed = response.data;
            }).catch(() => { this.sed = { ativa: false }; });
        },
        // Veio do "NOVO ALUNO" da listagem, que já conferiu a SED: traz a ficha escolhida ou os dados digitados.
        aplicarVerificacaoSed(){

            const q = this.$route.query || {};

            if(this.paramId || this.$route.params.id) return;

            if(q.sed_ra){
                const p = String(q.sed_ra).split('|');
                this.sedBusca.feita = true;
                this.usarCadastroSed({ ra: { numero: p[0], digito: p[1] || '', uf: p[2] || 'SP' } });
                return;
            }

            // Os campos digitados no modal (nome, nascimento, mãe, CPF, certidão) entram pelo watcher de paramId, que já lê a URL.
            if(q.sed_novo){
                this.sedBusca.feita = true;
                Vue.set(this.dados, 'sed_cadastrar_novo', true);
            }
        },
        rotuloConfianca(c){
            return { ALTA: 'Mesmo aluno', MEDIA: 'Provavelmente o mesmo', BAIXA: 'Parecido' }[c] || c;
        },
        buscarNaSed(){

            if(!this.dados.nome || !this.dados.data_nascimento){
                window.eventBus.$emit('alert', {msg: 'Informe ao menos o nome e a data de nascimento para buscar na SED.', type: 'warning'});
                return;
            }

            this.sedBusca.visivel = true;
            this.sedBusca.carregando = true;
            this.sedBusca.candidatos = [];

            const filtro = { nome: this.dados.nome, mae: this.dados.mae, data_nascimento: this.dados.data_nascimento, cpf: this.dados.cpf, registro_nasc_novo: this.dados.registro_nasc_novo, nis: this.dados.nis };

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/sed/aluno/buscar`, filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.sedBusca.carregando = false;

                if(response.data.throw){
                    this.sedBusca.visivel = false;
                    window.eventBus.$emit('throw', response.data.throw);
                    return;
                }

                this.sedBusca.candidatos = response.data.candidatos || [];
                this.sedBusca.feita = true;

            }).catch((error) => { this.sedBusca.carregando = false; this.sedBusca.visivel = false; this.$store.commit('throwException', error); });
        },
        // Traz a ficha da SED para o formulário. Nenhum RA novo será criado ao salvar.
        usarCadastroSed(c){

            this.sedBusca.carregando = true;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/sed/aluno/ficha`, { ra: c.ra }, this.$store.getters.getHeaderAuth).then(response => {

                this.sedBusca.carregando = false;

                if(response.data.throw){ window.eventBus.$emit('throw', response.data.throw); return; }

                Object.keys(response.data.dados).forEach(campo => {
                    const valor = response.data.dados[campo];
                    if(valor !== null && valor !== '') Vue.set(this.dados, campo, valor);
                });

                Vue.set(this.dados, 'sed_ra', response.data.sed_ra);
                this.sedBusca.visivel = false;

                window.eventBus.$emit('alert', {msg: 'Dados trazidos da SED. Confira, complete o que faltar e salve.', type: 'success'});

            }).catch((error) => { this.sedBusca.carregando = false; this.$store.commit('throwException', error); });
        },
        naoEhNenhumDaSed(){
            Vue.set(this.dados, 'sed_cadastrar_novo', true);
            this.sedBusca.visivel = false;
        },
        checkIfAlunoExist(){

            if(this.dados.nome){
                this.formatData('nome');
            }

            if(this.dados.data_nascimento){
                this.formatData('data_nascimento', 10);
            }

            if(this.editAluno){
                return false;
            }

            if(this.dados.nome && this.dados.data_nascimento){

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/checkIfAlunoExist`, {nome: this.dados.nome, data_nascimento: this.dados.data_nascimento}, this.$store.getters.getHeaderAuth).then(response => {

                    if(response.data.length > 0){

                        this.cadastrosSimilares = response.data;
                        this.dialogCadastrosSimilares = true;
                    }

                }).catch((error) => { this.$store.commit('throwException', error); });
            }

        },
        initFormAluno(){
        //INICIA FORMULÁRIO DE ALUNO

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/aluno/initFormAluno`, this.$store.getters.getHeaderAuth).then(response => {

                this.alergias = response.data.alergias;
                this.doencas = response.data.doencas;
                this.transtornoAprendizagem = response.data.transtornoAprendizagem;
                this.deficiencias = response.data.deficiencias;
                this.paises = response.data.paises;
                this.recursosProvas = response.data.recursosProvas;
                this.povosIndigenas = response.data.povosIndigenas;
                this.religioes = response.data.religioes;
                this.tiposRendaFamiliar = response.data.tiposRendaFamiliar;
                this.situacoesFamiliares = response.data.situacoesFamiliares;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getAlunoById(id){
        //BUSCA ALUNO PARA SER EDITADO

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/aluno/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                if(response.data.data_nascimento)
                    response.data.data_nascimento = this.$moment(response.data.data_nascimento).format('DD/MM/YYYY');

                if(response.data.data_emissao_rg)
                    response.data.data_emissao_rg = this.$moment(response.data.data_emissao_rg).format('DD/MM/YYYY');

                if(response.data.data_emissao_registro)
                    response.data.data_emissao_registro = this.$moment(response.data.data_emissao_registro).format('DD/MM/YYYY');

                this.geo.carregando = true;
                this.dados = JSON.parse(JSON.stringify(response.data));

                // A cidade gravada precisa existir como opção do select remoto.
                if(this.dados.cidade_id && this.dados.cidade && this.dados.cidade.nome)
                    this.definirCidade(this.dados.cidade_id, this.dados.cidade.nome, this.dados.cidade.estado ? (this.dados.cidade.estado.uf || this.dados.cidade.estado.nome) : '');

                this.$nextTick(() => { this.geo.carregando = false; this.localizarSilencioso(); });

                this.fotoFile = '';
                this.fotoUrl = this.dados.foto_path ? `${this.$store.state.config.baseUrlApi}/storage/` + this.dados.foto_path : '';

                if(this.dados.deficiencias && this.dados.deficiencias.length == 0){
                    this.dados.deficiencias.push({
                        deficiencia_id: '',
                        cid10: '',
                        nome: ''
                        // arquivosCid10: []
                    });
                }

                // Aluno sem matrícula ativa (ex.: trazido da SED, transferido): a nova matrícula é na instituição selecionada.
                if(!this.dados.matricula) this.dados.matricula = { id: null, referencia_nacional: null, turma_id: null, instituicao_id: null };
                if(!this.dados.matricula.instituicao_id && this.$store.state.config.instituicao && this.$store.state.config.instituicao.id)
                    this.dados.matricula.instituicao_id = this.$store.state.config.instituicao.id;

                this.getRefNacionalByInstituicao();

                // Acentuação conforme a instituição do aluno editado
                if(this.dados.matricula && this.dados.matricula.instituicao_id)
                    this.carregarAcentuacaoInstituicao(this.dados.matricula.instituicao_id);

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        showSearchCartorio(){
        //ABRE MODAL DE BUSCA DE CARTÓRIO

            this.searchCartorio = true;
        },
        showSearchMunNascimento(){
        //ABRE MODAL DE BUSCA DE MUNC. NASCIMENTO

            this.searchCidade = true;
        },
        showSearchEndereco(){
        //ABRE MODAL DE BUSCA DE ENDEREÇO

            this.searchEndereco = true;
        },
        emitCartorio(cartorio){
        //QUANDO UM CARTÓRIO É SELECIONADO

            this.searchCartorio = false;
            this.dados.cartorio = cartorio;
            this.dados.cartorio_id = cartorio.id;
        },
        showSearchCbo(alvo){
        //ABRE MODAL DE BUSCA DE CBO PARA A FILIAÇÃO (alvo: 'mae' ou 'pai')

            this.cboAlvo = alvo;
            this.searchCbo = true;
        },
        emitCbo(cbo){
        //QUANDO UM CBO É SELECIONADO — VINCULA À FILIAÇÃO ALVO

            if(this.cboAlvo == 'mae'){
                this.dados.cbo_mae = cbo;
                this.dados.cbo_mae_id = cbo.id;
            }else if(this.cboAlvo == 'pai'){
                this.dados.cbo_pai = cbo;
                this.dados.cbo_pai_id = cbo.id;
            }

            this.searchCbo = false;
            this.cboAlvo = null;
        },
        removerCbo(alvo){
        //REMOVE O VÍNCULO DE CBO DA FILIAÇÃO

            if(alvo == 'mae'){
                this.dados.cbo_mae = { id: '', codigo: '', nome: '' };
                this.dados.cbo_mae_id = '';
            }else if(alvo == 'pai'){
                this.dados.cbo_pai = { id: '', codigo: '', nome: '' };
                this.dados.cbo_pai_id = '';
            }
        },
        uploadFotoIfNeeded(alunoId){
        //ENVIA A FOTO DO ALUNO (se selecionada) APÓS O CADASTRO/EDIÇÃO

            if(!this.fotoFile || !alunoId){ return Promise.resolve(); }

            const fd = new FormData();
            fd.append('foto', this.fotoFile);

            return this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/aluno/uploadFoto/` + alunoId,
                fd,
                this.$store.getters.getHeaderFileAuth
            );
        },
        onFotoErro(msg){
            if(msg){ window.eventBus.$emit('alert', {msg, type: 'warning'}); }
        },
        onFotoDelete(){
        //REMOVE A FOTO (no backend se estiver editando e já houver foto salva)

            this.fotoFile = '';
            if(this.editAluno && this.dados.id && this.fotoUrl){
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/aluno/removerFoto/` + this.dados.id, this.$store.getters.getHeaderAuth).then(() => {
                    this.fotoUrl = '';
                }).catch((e) => { this.$store.commit('throwException', e); });
            }
        },
        emitMunNascimento(municipio_nascimento){
        //QUANDO UM MUNC. NASCIMENTO É SELECIONADO

            this.searchCidade = false;
            this.dados.municipio_nascimento = municipio_nascimento;
            this.dados.municipio_nascimento_id = municipio_nascimento.id;
        },
        emitEndereco(endereco){
        //QUANDO UM ENDEREÇO É SELECIONADO

            this.searchEndereco = false;
            this.dados.cep = endereco.cep;
            this.dados.logradouro = endereco.logradouro.nome;
            this.dados.bairro = endereco.bairro.nome;
            this.definirCidade(endereco.cidade.id, endereco.cidade.nome, endereco.cidade.estado ? (endereco.cidade.estado.uf || endereco.cidade.estado.nome) : '');
        },
        async buscarViaCep(){

            const cepLimpo = (this.dados.cep || '').replace(/\D/g, '');
            if(cepLimpo.length !== 8 || this.buscandoCep) return;

            this.buscandoCep = true;

            try {
                const end = await this.consultarCep(cepLimpo);

                if(!end){
                    window.eventBus.$emit('alert', { msg: 'Atenção! CEP não encontrado. Preencha o endereço manualmente.', type: 'warning' });
                    return;
                }

                // Só sobrescreve o que o CEP trouxe: CEP geral de município vem sem rua e sem bairro.
                if(end.logradouro) this.dados.logradouro = this.tratarAcento(end.logradouro.toUpperCase());
                if(end.bairro)     this.dados.bairro = this.tratarAcento(end.bairro.toUpperCase());
                if(end.ibge)       this.definirCidade(Number(end.ibge), this.tratarAcento((end.localidade || '').toUpperCase()), end.uf || '');

                // Endereço preenchido: já tenta localizar (sem abrir nada).
                this.$nextTick(() => this.localizarSilencioso());

            } catch(error) {
                window.eventBus.$emit('alert', { msg: 'Atenção! Erro ao buscar CEP.', type: 'warning' });
            } finally {
                this.buscandoCep = false;
            }
        },
        // ViaCEP primeiro; se não conhece o CEP (é o caso do CEP geral 13940-000), BrasilAPI. Ambos devolvem o IBGE,
        // que é o id da cidade no SMGE. null = nenhum dos dois encontrou.
        async consultarCep(cepLimpo){
            try {
                const { data } = await this.$axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);
                if(!data.erro) return { logradouro: data.logradouro, bairro: data.bairro, localidade: data.localidade, uf: data.uf, ibge: data.ibge };
            } catch(e) { /* tenta o próximo */ }

            try {
                const { data } = await this.$axios.get(`https://brasilapi.com.br/api/cep/v1/${cepLimpo}`);
                if(data && data.ibge && data.ibge.city) return { logradouro: data.street, bairro: data.neighborhood, localidade: data.city, uf: data.state, ibge: data.ibge.city };
            } catch(e) { /* não encontrado */ }

            return null;
        },
        // ------------------------------------------------------------ cidade (select remoto)
        buscarCidades(termo){
            const q = (termo || '').trim();
            if(q.length < 2){ return; }

            this.buscandoCidade = true;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/cidade/searchByNome`, { query: this.$removerAcentos(q) }, this.$store.getters.getHeaderAuth).then(response => {
                this.buscandoCidade = false;
                this.cidadesOpcoes = response.data || [];
            }).catch(() => { this.buscandoCidade = false; });
        },
        // Garante a opção no select e mantém dados.cidade (usado em outras partes do sistema) coerente com cidade_id.
        definirCidade(id, nome, uf){
            if(!id) return;
            const rotulo = nome + (uf ? ' - ' + uf : '');
            if(!this.cidadesOpcoes.some(c => c.id === id)) this.cidadesOpcoes.push({ id, nome: rotulo });
            this.dados.cidade_id = id;
            this.dados.cidade = { id, nome, estado: { id: '', nome: uf } };
        },
        selecionarCidade(id){
            const c = this.cidadesOpcoes.find(x => x.id === id);
            if(c){
                const partes = String(c.nome).split(' - ');
                this.dados.cidade = { id, nome: partes[0], estado: { id: '', nome: partes[1] || '' } };
            } else {
                this.dados.cidade = { id: '', nome: '', estado: { id: '', nome: '' } };
            }
            this.localizarSilencioso();
        },
        limparEndereco(){
            this.dados.logradouro = '';
            this.dados.bairro = '';
            this.dados.cidade = { id: '', nome: '', estado: { id: '', nome: '' } };
            this.dados.cidade_id = '';
        },
        confirmarJustificativaDocumentos(){
            Vue.set(this.dados, 'sed_justificativa_documentos', this.justificativaDocumentos.valor);
            this.justificativaDocumentos.visivel = false;
            this.onSubmitAluno();
        },
        onSubmitAluno(){
        //CHAMADO NO SUBMIMT DO FORMULÁRIO DE ALUNO

            document.getElementById("btn-aluno").focus();

            this.$refs.dados.validate( async (valid) => { if(valid){

                try{

                    let deficiencias = [];
                    for(let i in this.dados.deficiencias){
                        if(this.dados.deficiencias[i].deficiencia_id){
                            deficiencias.push(this.dados.deficiencias[i]);
                        }else if(!this.dados.deficiencias[i].deficiencia_id && this.dados.deficiencias[i].cid10){
                            this.$alert('Você informou a cid e não informou a deficiência.', 'Atenção', { confirmButtonText: 'OK' });
                            return;
                        }
                    }
                    if(deficiencias.length > 0){
                        for(let i in deficiencias){
                            for(let j in this.deficiencias){

                                if(deficiencias[i].deficiencia_id == this.deficiencias[j].id){
                                    deficiencias[i].nome = this.deficiencias[j].nome;
                                }
                            }
                        }
                    }
                    this.dados.deficiencias = deficiencias.length > 0 ? deficiencias : null; 

                    // Integração SED: a escola em nome da qual se cadastra; cadastro novo exige a busca antes.
                    if(this.sed.ativa || this.sed.consulta){

                        if(this.sed.ativa && this.$store.state.config.instituicao && this.$store.state.config.instituicao.id) Vue.set(this.dados, 'sed_instituicao_id', this.$store.state.config.instituicao.id);

                        // O cadastro novo chega aqui pelo modal "Novo aluno", que já conferiu a SED; o servidor refaz a busca.
                    }

                    // Coordenada do endereço: o servidor geocodifica; se não achar com precisão, abre o mapa e espera o pino.
                    if(this.geo.ativa && !(await this.garantirGeolocalizacao())) return;

                    let res;
                    window.eventBus.$emit('loading', true);

                    if(this.editAluno){

                        res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth);

                    }else{

                        res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/store`, this.dados, this.$store.getters.getHeaderAuth);
                        Vue.set(this.dados, 'id', res.data.id);

                        // Integração SED: o RA vem na resposta quando a ficha foi criada/vinculada na SED ao salvar.
                        ['codigo_sed', 'sed_ra_digito', 'sed_ra_uf'].forEach(c => { if(res.data && res.data[c] !== undefined) Vue.set(this.dados, c, res.data[c]); });

                        // Envia os anexos selecionados durante o cadastro novo, já vinculados ao id criado.
                        if(res.data.id && this.$refs.anexos){
                            await this.$refs.anexos.vincularPendentes(res.data.id);
                        }
                    }

                    window.eventBus.$emit('loading', false);

                    const pedeJustificativa = res.data.throw && res.data.throw.find(t => t && t.codigo === 'SED_PEDE_JUSTIFICATIVA_DOCUMENTOS');

                    if(pedeJustificativa){

                        // A SED exige o motivo da falta de documentos: abre o modal em vez de só mostrar o erro.
                        this.justificativaDocumentos = { visivel: true, valor: this.dados.sed_justificativa_documentos || null, outras: pedeJustificativa.outras_mensagens || [] };

                    }else if(typeof res.data.throw !== 'undefined'){

                        if(this.dados.autorizacao_smed){

                            this.$alert('O código de autorização informado não é válido.', 'Atenção', { confirmButtonText: 'OK' });

                        }else{

                            window.eventBus.$emit('throw', res.data.throw);
                            this.input_autorizacao = true;
                        }

                    }else{

                        // Upload da foto (se selecionada), após o aluno já ter id.
                        if(this.fotoFile && this.dados.id){
                            window.eventBus.$emit('loading', true);
                            await this.uploadFotoIfNeeded(this.dados.id);
                            window.eventBus.$emit('loading', false);
                        }

                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('onSubmitFormAluno', this.dados);
                    }

                }catch(e){ window.eventBus.$emit('loading', false); this.$store.commit('throwException', e); console.log(e); }

            }else{ window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'}); }});
        },
        changeModeloRegistro(){
        //QUAND O SELECT DE MODELO DE REGISTRO É ALTERADO

            this.dados.registro_nasc_novo = '';
            this.dados.reg_nasc_antigo_registro = '';
            this.dados.reg_nasc_antigo_folha = '';
            this.dados.reg_nasc_antigo_livro = '';
            this.dados.data_emissao_registro = '';
            this.dados.cartorio_id = '';
            this.dados.cartorio = { id: '', nome: '', cidade: { id: '', nome: '' }};
        },
        changeNacionalidade(){
        //QUANDO O SELECT DE NACIONALIDADE É ALTERADO

            if(this.dados.nacionalidade == 1){

                this.dados.pais_id = 1;

                setTimeout(()=>{

                    this.showSearchMunNascimento();

                }, 500);

            }else if(this.dados.nacionalidade == 2){

                this.dados.pais_id = 1;

                this.dados.municipio_nascimento_id = '';
                this.dados.municipio_nascimento = { id: '', nome: '' };

            }else if(this.dados.nacionalidade == 3){

                this.dados.pais_id = '';
                this.dados.pais.id = '';
                this.dados.pais.nome = '';

                this.dados.municipio_nascimento_id = '';
                this.dados.municipio_nascimento.id = '';
                this.dados.municipio_nascimento.nome = '';
            }

        },
        formatData(field, size = null){
        //TRATA OS INPUTS - LETRA MAIÚCULA

            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.tratarAcento(this.dados[field]);
        },
        tratarAcento(valor){
        //MANTÉM A ACENTUAÇÃO SE A INSTITUIÇÃO PERMITIR; SENÃO, REMOVE

            if(this.acentuacaoInstituicao)
                return valor;

            return this.$removerAcentos(valor);
        },
        carregarAcentuacaoInstituicao(instituicaoId){
        //BUSCA A CONFIG DE ACENTUAÇÃO DA INSTITUIÇÃO ATIVA (parametros_sistema, por instituição)

            if(!instituicaoId)
                return;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/parametro-sistema/getValor/aluno.permite_acentuacao?instituicao_id=` + instituicaoId, this.$store.getters.getHeaderAuth).then(response => {

                const valor = response.data && response.data.valor;
                this.acentuacaoInstituicao = (valor === true || valor === '1' || valor === 1 || valor === 'true');

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        resetForm(){

            this.dados = {
                alergias: [],
                doencas: [],
                transtornoAprendizagem: [],
                deficiencias: [{
                    deficiencia_id: '',
                    cid10: '',
                    nome: ''
                    // arquivosCid10: []
                }],
                id: '',
                cpf: '',
                rg: '',
                data_emissao_rg: '',
                orgao_emissor_rg: '',
                uf_rg: '',
                nome: '',
                inep: '',
                nome_aluno_censo: '',
                data_nascimento: '',
                pai: '',
                mae: '',
                responsavel: '',
                parentesco: '',
                sexo: '',
                cor: '',
                nacionalidade: '',
                cartao_sus: '',
                nis: '',
                modelo_registro: '',
                tipo_registro: '',
                registro_nasc_novo: '',
                reg_nasc_antigo_registro: '',
                reg_nasc_antigo_folha: '',
                reg_nasc_antigo_livro: '',
                data_emissao_registro: '',
                logradouro: '',
                numero: '',
                bairro: '',
                cep: '',
                complemento: '',
                localizacao_zona: '',
                telefone: '',
                celular: '',
                celular_outro: '',
                recebe_bolsa_familia: '',
                religiao_id: '',
                tipo_renda_familiar_id: '',
                situacao_familiar_id: '',
                cbo_mae_id: '',
                cbo_pai_id: '',
                cbo_mae: { id: '', codigo: '', nome: '' },
                cbo_pai: { id: '', codigo: '', nome: '' },
                observacao: '',
                situacao: '',
                pais_id: '',
                municipio_nascimento_id: '',
                cartorio_id: '',
                cidade_id: '',
                povo_indigena_id: '',
                cidade: {
                    id: '',
                    nome: '',
                    estado: {
                        id: '',
                        nome: ''
                    }
                },
                pais: {
                    id: '',
                    nome: ''
                },
                municipio_nascimento: {
                    id: '',
                    nome: ''
                },
                cartorio: {
                    id: '',
                    nome: '',
                    cidade: {
                        id: '',
                        nome: ''
                    }
                }
            };
        }
    },
    components:{ searchCartorio, searchCbo, searchCidade, searchEndereco, anexos, InputImage, mapaEndereco },
    watch: {
        'dados.logradouro': 'invalidarGeo',
        'dados.numero': 'invalidarGeo',
        'dados.bairro': 'invalidarGeo',
        'dados.cep': 'invalidarGeo',
        'dados.cidade_id': 'invalidarGeo',
        '$route.params.id'(value) {

            this.getAlunoById(value);
            this.editAluno = true;
        },
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getAlunoById(value);
                    this.editAluno = true;

                }else{
                    
                    this.resetForm();

                    // sed_ra = veio do "NOVO ALUNO" com um cadastro da SED escolhido: quem preenche é a ficha da SED.
                    if(Object.keys(this.$route.query).length !== 0 && !this.$route.query.sed_ra){

                        // A pré-matrícula manda a data em AAAA-MM-DD; o modal do "NOVO ALUNO" manda como foi digitada (DD/MM/AAAA).
                        const nasc = this.$route.query.data_nascimento || '';

                        this.dados.nome = this.$route.query.nome;
                        this.dados.data_nascimento = /^\d{2}\/\d{2}\/\d{4}$/.test(nasc) ? nasc : (nasc ? this.$moment(nasc).format('DD/MM/YYYY') : '');
                        this.dados.responsavel = this.$route.query.responsavel;

                        if(this.$route.query.mae) this.dados.mae = this.$route.query.mae;

                        if(this.$route.query.registro_nasc_novo) {
                            this.dados.modelo_registro = 1;
                            this.dados.registro_nasc_novo = this.$route.query.registro_nasc_novo;
                        }

                        this.dados.cpf = this.$route.query.cpf;
                        this.dados.celular = this.$route.query.celular;

                        if(this.$route.query.registro_nasc) {
                            this.dados.modelo_registro = 1;
                            this.dados.registro_nasc_novo = this.$route.query.registro_nasc;
                        }

                        this.checkIfAlunoExistByDocumento();

                    }else {

                        this.editAluno = false;
                    }
                }
            }
        }
    }
}
</script>
<style>
.sed-faixa { border: 1px solid #d9ecff; background: #f4f9ff; border-radius: 4px; padding: 8px 12px; margin-bottom: 12px; font-size: 13px; color: #337ab7; }
.sed-faixa i { margin-right: 6px; }
.sed-candidato { border: 1px solid #ebeef5; border-radius: 4px; padding: 10px 12px; margin-bottom: 10px; }
.sed-linha { font-size: 12px; color: #606266; margin-top: 3px; }
    .el-upload-list__item:first-child {
        margin-top: 5px !important;
    }
</style>